export type MenuPermissionKey =
  | 'dashboard'
  | 'clientes'
  | 'notas'
  | 'produtos'
  | 'conferencias_entrada'
  | 'contagens_nova'
  | 'contagens'
  | 'pagamentos'
  | 'contas_pagar'
  | 'contas_receber'
  | 'caixa'
  | 'fornecedores'
  | 'ocorrencias'
  | 'usuarios';

export interface MenuPermission {
  key: MenuPermissionKey;
  label: string;
  path: string;
  exact?: boolean;
}

export interface MenuGroup {
  label: string;
  items: MenuPermission[];
}

export const MENU_GROUPS: MenuGroup[] = [
  {
    label: 'Visão geral',
    items: [{ key: 'dashboard', label: 'Dashboard', path: '/', exact: true }]
  },
  {
    label: 'Operação',
    items: [
      { key: 'notas', label: 'Estoque por cliente', path: '/notas' },
      { key: 'conferencias_entrada', label: 'Conferência de entrada', path: '/conferencias-entrada' },
      { key: 'contagens_nova', label: 'Nova contagem', path: '/contagens/nova' },
      { key: 'contagens', label: 'Histórico', path: '/contagens' },
      { key: 'ocorrencias', label: 'Ocorrências', path: '/ocorrencias' }
    ]
  },
  {
    label: 'Cadastros',
    items: [
      { key: 'clientes', label: 'Clientes', path: '/clientes' },
      { key: 'produtos', label: 'Produtos', path: '/produtos' },
      { key: 'fornecedores', label: 'Fornecedores', path: '/fornecedores' }
    ]
  },
  {
    label: 'Financeiro',
    items: [
      { key: 'contas_pagar', label: 'Contas a pagar', path: '/contas-pagar' },
      { key: 'contas_receber', label: 'Contas a receber', path: '/contas-receber' },
      { key: 'pagamentos', label: 'Pagamentos de produção', path: '/pagamentos' },
      { key: 'caixa', label: 'Caixa', path: '/caixa' }
    ]
  },
  {
    label: 'Administração',
    items: [{ key: 'usuarios', label: 'Usuários', path: '/usuarios' }]
  }
];

export const MENU_PERMISSIONS: MenuPermission[] = MENU_GROUPS.flatMap((group) => group.items);

export const ALL_MENU_PERMISSION_KEYS = MENU_PERMISSIONS.map((item) => item.key);
